module.exports = __webpack_public_path__ + "img/com_PLN.a3377f30.png";